import { getBaseUrl, getSessionTicket } from '../../config';

export type Config = {
  key: string;
  value: string;
}[];

export async function getConfig(): Promise<Config> {
  const res = await fetch(getBaseUrl() + '/EPG/JSON/GetCustomizeConfig', {
    method: 'POST',
    headers: { SessionTicket: getSessionTicket() },
    body: JSON.stringify({
      queryType: 0,
    }),
  });

  const data = (await res.json()) as { extensionInfo: { key: string; value: string }[] };
  return data.extensionInfo;
}
